import reducer from "./reducer";
export { default as MyGroups } from "./components/index";
export { default as myGroupsReducerName } from "./constants";
export default reducer;
